module.exports = __webpack_public_path__ + "img/img02.64ab465a.png";